import { lazy } from 'react';
import urlPath from 'src/constants/urlPath';
import MainLayoutV2 from 'src/layouts/v2/MainLayout';
import TopicLayoutWrapper from 'src/layouts/v2/TopicLayout';
import ReportLayout from 'src/layouts/v2/ReportLayout';
import type { RouteGroup } from './types';
import TicketLayout from 'src/layouts/v2/TicketLayout';
import ProposalLayout from 'src/layouts/v2/ProposalLayout';

// Lazy load V2 feature components
const UserGuides = lazy(() => import('src/pages/v2/UserGuide/UserGuides'));
const TopicConversationBox = lazy(() => import('src/pages/v2/Topic/TopicConversationBox'));
const ReportManagement = lazy(() => import('src/pages/v2/Report/ReportManagement'));
const ReportLeaveTicket = lazy(() => import('src/pages/v2/Report/LeaveTicket'));
const ReportOvertimeTicket = lazy(() => import('src/pages/v2/Report/OvertimeTicket'));
const PNL04 = lazy(() => import('src/pages/v2/Report/PNL04'));
const ReportBusinessTripTicket = lazy(() => import('src/pages/v2/Report/BusinessTripTicket'));
const ReportDailyInventoryJournal = lazy(() => import('src/pages/v2/Report/DailyInventoryJournal'));
const ReportBiometricData = lazy(() => import('src/pages/v2/Report/BiometricData'));
const Proposal = lazy(() => import('src/pages/v2/Temporary/Proposal'));
const ProposalForm = lazy(() => import('src/pages/v2/Temporary/Proposal/ProposalForm'));

export const featureRoutes: RouteGroup = [
  // User Guides
  {
    path: urlPath.userGuide.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: UserGuides,
    hasSidebar: false,
    hasSubHeader: true,
    isDisableFooter: true
  },

  // Topic/Communication
  {
    path: urlPath.topic.location,
    Layout: MainLayoutV2,
    SubLayout: TopicLayoutWrapper,
    Component: TopicConversationBox,
    hasSidebar: true,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: `${urlPath.topic.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TopicLayoutWrapper,
    Component: TopicConversationBox,
    hasSidebar: true,
    hasSubHeader: false,
    isDisableFooter: true
  },

  // Corporate Operations
  {
    path: urlPath.corporateOperation.location,
    Layout: MainLayoutV2,
    redirect: urlPath.myHandoverTicket.location,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true
  },
  // Reports
  {
    path: urlPath.report.location,
    Layout: MainLayoutV2,
    SubLayout: ReportLayout,
    Component: ReportManagement,
    hasSidebar: true,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: urlPath.reportLeaveTicket.location,
    Layout: MainLayoutV2,
    SubLayout: ReportLayout,
    Component: ReportLeaveTicket,
    hasSidebar: true,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: urlPath.reportOvertimeTicket.location,
    Layout: MainLayoutV2,
    SubLayout: ReportLayout,
    Component: ReportOvertimeTicket,
    hasSidebar: true,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: urlPath.reportPNL04.location,
    Layout: MainLayoutV2,
    SubLayout: ReportLayout,
    Component: PNL04,
    hasSidebar: true,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: urlPath.reportBusinessTripTicket.location,
    Layout: MainLayoutV2,
    SubLayout: ReportLayout,
    Component: ReportBusinessTripTicket,
    hasSidebar: true,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: urlPath.reportDailyInventoryJournal.location,
    Layout: MainLayoutV2,
    SubLayout: ReportLayout,
    Component: ReportDailyInventoryJournal,
    hasSidebar: true,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: urlPath.reportBiometricData.location,
    checkPath: urlPath.reportBiometricData.location,
    Layout: MainLayoutV2,
    SubLayout: ReportLayout,
    Component: ReportBiometricData,
    isUsePathV2: true
  },
  // Temporary
  {
    path: urlPath.proposal.location,
    Layout: MainLayoutV2,
    SubLayout: ProposalLayout,
    Component: Proposal,
    hasSidebar: true,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: `${urlPath.proposalDetail.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: ProposalLayout,
    Component: ProposalForm,
    hasSidebar: true,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: `${urlPath.proposalAdd.location}`,
    Layout: MainLayoutV2,
    SubLayout: ProposalLayout,
    Component: ProposalForm,
    hasSidebar: true,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: `${urlPath.proposalEdit.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: ProposalLayout,
    Component: ProposalForm,
    hasSidebar: true,
    hasSubHeader: false,
    isDisableFooter: true
  }
];
